import { render, staticRenderFns } from "./SurveyRewardPopup.vue?vue&type=template&id=1738b069"
import script from "./SurveyRewardPopup.vue?vue&type=script&lang=js"
export * from "./SurveyRewardPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports